import { FormField, QuestionnaireDescription, useError } from "common";
import { useField } from "formik";
import React from "react";
import { FormatInput } from "../Input/FormatInput";
import { FieldProps } from "../Questionnaire/TextField";

export const DateOfBirthField = ({ name, field, isRequired, classNames }: FieldProps) => {
    const [props] = useField(name);
    const error = useError(name);
    const unexpectedPattern = /(\d{4})\D(\d{2})\D(\d{2})/gm; // occasionally, the dateOfBirth may be wrong formatted
    const groups: RegExpExecArray | null = unexpectedPattern.exec(props.value);
    if (groups && (groups?.length ?? 0) >= 4) {
        // change input of like YYYY-DD-MM to MM/DD/YYYY
        props.value = `${groups[2]}/${groups[3]}/${groups[1]}`;
    }

    return (
        <FormField label={field.label} name={name} classNames={{ label: classNames?.label }}>
            <QuestionnaireDescription field={field} />
            <FormatInput
                {...props}
                isError={!!error}
                allowEmptyFormatting={false}
                format="##/##/####" // Hans off! Do not change format, otherwise you'll have to read the all this ticket related stuff https://xola01.atlassian.net/browse/X2-5120
                placeholder="MM/DD/YYYY"
                isRequired={isRequired}
            />
        </FormField>
    );
};

export const getISOFormattedDateString = (value: string, ensureDayAtEnd?: boolean) => {
    const pattern = /(\d{2})\D(\d{2})\D(\d{4})/gm;
    const groups: RegExpExecArray | null = pattern.exec(value);
    if (groups && (groups?.length ?? 0) >= 4) {
        // change input of like MM/DD/YYYY to YYYY-MM-DD
        let formattedDate = `${groups[3]}-${groups[1]}-${groups[2]}`;
        if (ensureDayAtEnd && Number(groups[1]) > 12 && Number(groups[1]) <= 31 && Number(groups[2]) <= 12) {
            // using groups[1] as DD part
            formattedDate = `${groups[3]}-${groups[2]}-${groups[1]}`;
        }
        return formattedDate;
    }

    return value;
};
